import { ArrowRight, Calendar, Image as ImageIcon, Target, Bird, Crosshair } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';
import StateCard from '../../../../platform/components/feedback/StateCard';

const ClubEvents = ({ events = [] }) => {
    const parseEventDate = (value) => {
        if (!value) return null;

        if (typeof value === 'string') {
            const trimmedValue = value.trim();

            if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmedValue)) {
                const [day, month, year] = trimmedValue.split('/').map(Number);
                const localDate = new Date(year, month - 1, day);
                return Number.isNaN(localDate.getTime()) ? null : localDate;
            }

            if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedValue)) {
                const [year, month, day] = trimmedValue.split('-').map(Number);
                const localDate = new Date(year, month - 1, day);
                return Number.isNaN(localDate.getTime()) ? null : localDate;
            }
        }

        const parsedDate = new Date(value);
        return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    };

    const formatDate = (dateValue) => {
        const date = parseEventDate(dateValue);
        if (!date) {
            return { day: 'TBC', month: 'Date' };
        }

        return {
            day: date.getDate(),
            month: date.toLocaleString('default', { month: 'short' })
        };
    };

    const resolveEventType = (eventType) => {
        const normalized = String(eventType || '').trim().toLowerCase();
        if (normalized === 'rifle') return 'Rifle';
        if (normalized === 'game') return 'Game';
        return 'Clay';
    };

    const getTypeIcon = (eventType) => {
        switch (resolveEventType(eventType)) {
            case 'Rifle':
                return <Target size={12} />;
            case 'Game':
                return <Bird size={12} />;
            default:
                return <Crosshair size={12} />;
        }
    };

    return (
        <div className='home-club-events'>
            <div className="home-club-events-heading">
                <h5>Upcoming Events</h5>
                <Link to="/dashboard/score">
                    View All
                    <ArrowRight className='ms-1' size={14} />
                </Link>
            </div>
            <div className="club-events-list">
                {events.length > 0 ? (
                    events.slice(0, 4).map((event, index) => {
                        const { day, month } = formatDate(event.date);
                        const eventType = resolveEventType(event.eventType);
                        return (
                            <div className="club-event-item" key={index}>
                                <div className="club-event-date">
                                    <span>{day}</span>
                                    <span>{month}</span>
                                </div>
                                <div className="club-event-info">
                                    <div className="club-event-info-top">
                                        <h6>{event.name}</h6>
                                        <span className={`club-event-type club-event-type-${eventType.toLowerCase()}`}>
                                            {getTypeIcon(event.eventType)}
                                            {eventType}
                                        </span>
                                    </div>
                                    <p>{event.location}</p>
                                    {(event.coverImageUrl || event.imageCount > 0) && (
                                        <div className="club-event-media">
                                            {event.coverImageUrl ? (
                                                <img src={event.coverImageUrl} alt={`${event.name} preview`} className="club-event-cover" />
                                            ) : null}
                                            <span className="club-event-media-count">
                                                <ImageIcon size={12} />
                                                {event.imageCount || 1} photo{(event.imageCount || 1) === 1 ? '' : 's'}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <StateCard
                        icon={Calendar}
                        title="No upcoming events"
                        description="Create or join an event to keep your next session visible here."
                        actionLabel="Go To Scoring"
                        actionTo="/dashboard/score"
                        compact
                    />
                )}
            </div>
        </div>
    );
};

export default ClubEvents;
